module.exports = __webpack_public_path__ + "static/media/ShulRendering.441879dc.jpeg";